import { useMemo } from 'react'
import { MultiLineTextTabDef } from '../../../../../containers/SingleSheetV2/tab/model'
import { useIntl } from 'react-intl'

export const useMultiLineTexTabDefs = (): MultiLineTextTabDef[] => {
  const intl = useIntl()
  const tabDefs = useMemo(
    () => [
      {
        label: intl.formatMessage({ id: 'wbsItem.description' }),
        field: 'description',
      },
      {
        label: intl.formatMessage({ id: 'wbsItem.startIf' }),
        field: 'startIf',
      },
      {
        label: intl.formatMessage({ id: 'wbsItem.completeIf' }),
        field: 'completeIf',
      },
    ],
    []
  )
  return tabDefs
}
export const useMultiLineTexTabDefsOnlyDescription =
  (): MultiLineTextTabDef[] => {
    const intl = useIntl()
    const tabDefs = useMemo(
      () => [
        {
          label: intl.formatMessage({ id: 'wbsItem.description' }),
          field: 'description',
        },
      ],
      []
    )
    return tabDefs
  }
